import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-auth-callback',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthCallbackComponent implements OnInit {

  constructor(private readonly oidcSecurityService: OidcSecurityService) {

  }

  ngOnInit(): void {
    //necessario se non c'è in app.component.ts
    this.oidcSecurityService.checkAuth().subscribe(() => {
    });
  }

}
